import { createSetlist } from '@music-vine/setlist';
import * as Sentry from '@sentry/nextjs';

const isProd = process.env.NEXT_PUBLIC_ENV === 'production';

// Found here: https://cloud.typesense.org/clusters/3feynu8vjgbqkl27p
const productionNodes = [
  {
    host: '3feynu8vjgbqkl27p-1.a1.typesense.net',
    port: 443,
    protocol: 'https',
  },
  {
    host: '3feynu8vjgbqkl27p-2.a1.typesense.net',
    port: 443,
    protocol: 'https',
  },
  {
    host: '3feynu8vjgbqkl27p-3.a1.typesense.net',
    port: 443,
    protocol: 'https',
  },
];

// Typesense will only fallback to nodes when nearestNode is down.
export const setlist = createSetlist({
  nearestNode: {
    host: process.env.NEXT_PUBLIC_TYPESENSE_URL,
    port: 443,
    protocol: 'https',
  },
  nodes: isProd
    ? productionNodes
    : [
        {
          host: process.env.NEXT_PUBLIC_TYPESENSE_URL,
          port: 443,
          protocol: 'https',
        },
      ],
  apiKey: process.env.NEXT_PUBLIC_TYPESENSE_API_KEY ?? '',
  connectionTimeoutSeconds: 6,
  onError: (error, { operation, ...extra }) =>
    Sentry.captureException(error, { tags: { operation }, extra }),
  // Disabled for now as it may be causing issues with search redirects - SB
  // useServerSideSearchCache: isProd,
  // cacheSearchResultsForSeconds: isProd ? 300 : 0,
});
